/* Display-only tabs. Pricing and checkout remain server-rendered / provider-owned. */
(() => {
  const key = 'kuuraii-recent-products-v1';
  let recent = [];
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) recent = saved.filter(p => p && typeof p.url === 'string' && p.url.startsWith('/products/')).slice(0, 8);
    const product = document.querySelector('[data-kr-recent-product]');
    if (product) {
      const { url, title, image, price } = product.dataset;
      recent = [{ url, title, image, price }, ...recent.filter(p => p.url !== url)].slice(0, 8);
      sessionStorage.setItem(key, JSON.stringify(recent));
    }
  } catch (_) { /* Browsing works normally when storage is unavailable. */ }

  function showRecent(drawer) {
    const panel = drawer.querySelector('[data-cart-recent]');
    const list = panel.querySelector('.kr-cart-recent__list');
    list.replaceChildren();
    panel.querySelector('p').hidden = recent.length > 0;
    recent.forEach(product => {
      const link = document.createElement('a');
      link.className = 'kr-cart-recent__item';
      link.href = product.url;
      const img = document.createElement('img');
      img.alt = ''; img.loading = 'lazy'; img.width = 80; img.height = 95;
      // Only the same Shopify CDN used by the storefront may supply stored images.
      try {
        const url = new URL(product.image, location.origin);
        if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) img.src = url.href;
      } catch (_) { /* Leave invalid images unset. */ }
      const copy = document.createElement('span'); copy.textContent = product.title || '';
      const price = document.createElement('small'); price.textContent = product.price || '';
      copy.append(price); link.append(img, copy); list.append(link);
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-tab]');
    if (!button) return;
    const drawer = button.closest('.kr-cart-review');
    if (!drawer) return;
    const recentSelected = button.dataset.cartTab === 'recent';
    drawer.querySelectorAll('[data-cart-tab]').forEach(tab => {
      const selected = tab === button;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-pressed', String(selected));
    });
    const items = drawer.querySelector('cart-drawer-items');
    const rewards = drawer.querySelector('.kr-cart-rewards');
    if (items) items.hidden = recentSelected;
    if (rewards) rewards.hidden = recentSelected;
    drawer.querySelector('[data-cart-recent]').hidden = !recentSelected;
    if (recentSelected) showRecent(drawer);
  });
})();

(() => {
  function syncPrepaidCartBars() {
    const state = document.querySelector('#CartDrawer [data-kr-eligible-subtotal]');
    if (!state) return;
    const eligible = Number(state.dataset.krEligibleSubtotal || 0);
    const subtotal = Number(state.dataset.krCartSubtotal || 0);
    const money = value => new Intl.NumberFormat('en-IN', {style: 'currency', currency: 'INR', maximumFractionDigits: value % 100 ? 2 : 0}).format(value / 100);
    document.querySelectorAll('[data-collection-cartbar]').forEach(bar => {
      let message;
      if (subtotal < 99900) message = bar.dataset.prepaidShipping?.replace('[amount]', money(99900 - subtotal));
      else if (eligible < 249900) message = bar.dataset.prepaidLocked?.replace('[amount]', money(249900 - eligible));
      else if (eligible < 500000) message = bar.dataset.prepaidFirst?.replace('[amount]', money(500000 - eligible));
      else message = bar.dataset.prepaidTop;
      const target = bar.querySelector('[data-cartbar-message]');
      if (target && message && target.textContent !== message) target.textContent = message;
      const progress = bar.querySelector('[data-cartbar-progress]');
      const width = Math.min(100, eligible / 5000) + '%';
      if (progress && progress.style.width !== width) progress.style.width = width;
    });
  }
  function initialise() {
    const drawer = document.querySelector('#CartDrawer');
    const bars = document.querySelectorAll('[data-collection-cartbar]');
    if (!drawer || !bars.length) return;
    const observer = new MutationObserver(syncPrepaidCartBars);
    observer.observe(drawer, {childList: true, subtree: true});
    bars.forEach(bar => observer.observe(bar, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']}));
    syncPrepaidCartBars();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
  else initialise();
})();
